<template>
  <Modal
    v-model="_value"
    width="500"
    title="HIK设置司机卡"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="80">
      <FormItem prop="positioningDeviceType" label="型号：A3">
        <checkbox v-model="positioningDeviceType">
        </checkbox>
      </FormItem>
      <FormItem v-if="positioningDeviceType" prop="driverCardNum" label="司机卡号">
        <Input v-model="setDriverCardParams.driverCardNum" placeholder="请输入司机卡号">
        </Input>
      </FormItem>
      <FormItem prop="driverLicenseNum" label="驾驶证号">
        <Input v-model="setDriverCardParams.driverLicenseNum" placeholder="请输入驾驶证号">
        </Input>
      </FormItem>
      <FormItem prop="driverName" label="驾驶员名">
        <Input v-model="setDriverCardParams.driverName" placeholder="请输入驾驶员名">
        </Input>
      </FormItem>
      <FormItem prop="indate" label="证件有效期">
        <DatePicker style="display: inline-block; width: 200px;" type="date" v-model="setDriverCardParams.indate"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import MaintainOrderAddMaintainDeviceRecordModal from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

export default {
  name: 'hiksetdrivercardmodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        driverCardNum: null,
        driverLicenseNum: null,
        driverName: null,
        indate: null,
      },

      positioningDeviceType:false,
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {
        this.setDriverCardParams.id = this._initValue
        this.setDriverCardParams.driverCardNum = null
        this.setDriverCardParams.driverLicenseNum = null
        this.setDriverCardParams.driverName = null
        this.setDriverCardParams.indate = null
        this.positioningDeviceType = false
      }
    },
    onCleanDriverCardParams () {
      this.setDriverCardParams.driverCardNum = null
      this.setDriverCardParams.driverLicenseNum = null
      this.setDriverCardParams.driverName = null
      this.setDriverCardParams.indate = null
      this.positioningDeviceType = false
    },
    onSendDriverCardParams () {
      if (this.setDriverCardParams.driverName == null){
        this.$Message.error("请输入驾驶员名")
      }
      if (this.setDriverCardParams.driverLicenseNum == null){
        this.$Message.error("请输入驾驶证号")
      }
      if (this.setDriverCardParams.indate == null){
        this.$Message.error("请输入有效期")
      }else {
        this.setDriverCardParams.indate = this.setDriverCardParams.indate.Format('yyyyMMdd')
      }
      let content = null
      if (this.positioningDeviceType){
        content = 'ICINFO:' + this.setDriverCardParams.driverName + ',' + this.setDriverCardParams.driverLicenseNum + ','  + this.setDriverCardParams.driverLicenseNum + ',' + this.setDriverCardParams.driverCardNum + ';A!!!'
      } else {
        // content = 'ICInfo:' + this.setDriverCardParams.driverLicenseNum + ',20990921,' + this.setDriverCardParams.driverLicenseNum + ',' + this.setDriverCardParams.driverName + ';A!!!'

        content = 'ICInfo:' + this.setDriverCardParams.driverLicenseNum + ',' + this.setDriverCardParams.indate + ',' + this.setDriverCardParams.driverLicenseNum + ',' + this.setDriverCardParams.driverName + ';A!!!'
      }
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: content, urgent: true }
      }).then(() => {
        this.$Message.success('发送成功')
        let queryParams = []
        queryParams.push(genQueryParam('terminalNum', 'EQ', this._terminalNumValue))
        store.dispatch('DriverCardDataResultServ_GetPage', {
          params: null,
          urlparams: {
            q: queryParams
          }
        }).then(res => {
          // console.log(res)
          if (store.getters.get_DriverCardDataResult_GetPageResult) {
            // console.log(store.getters.get_DriverCardDataResult_GetPageResult)
            let driverCardDataResults = store.getters.get_DriverCardDataResult_GetPageResult.content
            for (let i = 0; i < driverCardDataResults.length; i++) {
              if (driverCardDataResults[i].processState != 3) {
                driverCardDataResults[i].processRemark = '写卡'
                driverCardDataResults[i].processState = 3
                store.dispatch('DriverCardDataResultServ_AddProcessRemark', {
                  params: driverCardDataResults[i]
                }).then(() => {
                  // this.refreshPage(this.pageFilter)
                }).catch(err => {
                  this.$Message.error(err)
                })
              }
            }
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
